import * as React from 'react';
import {Query} from "react-apollo";
import gql from "graphql-tag";
import * as Grid from "react-bootstrap/lib/Grid";
import * as Row from "react-bootstrap/lib/Row";
import * as Col from "react-bootstrap/lib/Col";
import Application from "../metamodel/Application";
import SearchResultComponentFactory from "../factories/SearchResultComponentFactory";
import InputArgumentTypeFactory from "../factories/inputArgumentTypeFactory";
import Loader from "react-loaders";
import "loaders.css/loaders.css";
import IField, {FieldType} from "../metamodel/IField";
import * as Button from "react-bootstrap/lib/Button";
import EnumField from "../metamodel/Fields/EnumField";
import * as Modal from "react-bootstrap/lib/Modal";
import * as AutoAffix from "react-overlays/lib/AutoAffix";
import * as Clearfix from "react-bootstrap/lib/Clearfix";
import {Link} from "react-router-dom";
import Pagination from "../components/Pagination";
import BooleanField from "../metamodel/Fields/BooleanField";
import * as H from 'history';
import Entity from "../metamodel/Entity";
import FilterContainer from "./components/filters/FilterContainer";
import {EntityFacets, EntityFilters, SearchFilter} from "./types";
import EntityFiltersSerializer from "./EntityFiltersSerializer";
import Header from "./components/header";

/* tslint:disable:interface-name */
export interface HomePageProps {
    metaModel: Application,
    activeEntity: Entity,
    page: number,
    headerUrl: string,
    logoUrl: string,
    history: H.History
}

export interface HomePageState {
    showFilters: boolean,
    filters: {[key: string]: SearchFilter}
}

export default class Homepage extends React.Component<HomePageProps, HomePageState> {

    private metaModel: Application;
    private searchResultComponentFactory: SearchResultComponentFactory;

    constructor(props: HomePageProps, context: any) {
        super(props, context);
        const filters = EntityFiltersSerializer.deserialize(props.activeEntity, new URLSearchParams(props.history.location.search));
        this.metaModel = props.metaModel;
        this.searchResultComponentFactory = new SearchResultComponentFactory();
        this.state = {
            showFilters: false,
            filters
        };
        this.clearFilters = this.clearFilters.bind(this);
    }

    public componentDidUpdate(prevProps: HomePageProps) {
        const { search } = this.props.history.location;
        if (search !== prevProps.history.location.search) {
            this.setState({
                filters: EntityFiltersSerializer.deserialize(prevProps.activeEntity, new URLSearchParams(search))
            })
        }
    }

    public render() {
        return <>
        <Header metaModel={this.props.metaModel}/>
        <section id="main">
            <div className="header-page bg-scroll m-bottom-0"
                 style={{backgroundImage: `url('${this.props.headerUrl}')`}}>
                <div className="container">
                    <div className="header-page__form header-page__form--high">
                        <div className="tb">
                            <div className="tb__cell">
                                <Col sm={12} md={12}>
                                    <div className="header-page__banner text-center">
                                        <a href="/" target="_blank">
                                            <img className="header-img" width={200}
                                                 src={this.props.logoUrl}
                                                 alt="Logo"/>
                                        </a>
                                        <div className={"inline-block"}>
                                            <h2 className="banner__title">{this.metaModel.name}</h2>
                                            <Link to="/over-de-app"
                                               className="listgo-btn btn-primary">Meer informatie</Link>
                                        </div>
                                    </div>
                                </Col>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-page__breadcrumb">
                    <div className="container">
                        <ol className="wo_breadcrumb">
                            <li><span>Zoeken</span></li>
                        </ol>
                    </div>
                </div>
            </div>
            <div className="section p-top-10">
                <Grid>
                    <Query query={this.buildQuery()} fetchPolicy="cache-and-network"
                                  notifyOnNetworkStatusChange={true} variables={{...this.state.filters, offset: (this.props.page -1) * 30}}>
                        {({loading, error, data}) => {
                            if (error) {
                                console.error(error.message);
                                return error;
                            }
                            const handleModalShow = () => this.setState({showFilters: true});
                            const handleModalHide = () => this.setState({showFilters: false});
                            const scrollToTop = () =>  window.scrollTo({ top: 0, behavior: 'smooth' });
                            // @ts-ignore
                            // @ts-ignore
                            return <Row>
                                <Col smHidden={true} xsHidden={true} md={3} id={"filter-sidebar"}>
                                    {!this.state.showFilters ? this.renderFilters(data) : undefined}
                                </Col>
                                <Modal show={this.state.showFilters} onHide={handleModalHide}>
                                    <Modal.Header closeButton={true}>
                                        <Modal.Title>Filters</Modal.Title>
                                            <Button
                                                bsSize="xsmall"
                                                className={"listgo-btn modal-button"}
                                                onClick={this.clearFilters}>
                                                Reset alle filters
                                            </Button>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {this.state.showFilters ? this.renderFilters(data) : undefined}
                                    </Modal.Body>
                                </Modal>
                                <AutoAffix bottomClassName="visible-sm-block visible-xs-block"
                                           topClassName="visible-xs-block visible-sm-block"
                                           viewportOffsetTop={15}
                                           affixClassName="no-text visible-xs-block visible-sm-block"
                                           affixStyle={{right: 0}} autoWidth={false} container={this}>
                                    <Clearfix>
                                        <a
                                            className={"listgo-btn btn-primary pull-right"}
                                            onClick={handleModalShow}><i className="fa fa-filter"/>
                                            <span>Filters</span>
                                        </a>
                                    </Clearfix>
                                </AutoAffix>

                                <AutoAffix bottomClassName="visible-sm-block visible-xs-block"
                                           topClassName="hidden"
                                           affixClassName="no-text"
                                           affixStyle={{right: 0, bottom: 20, top: 'unset'}} autoWidth={false} container={this}>
                                    <Clearfix>
                                        <a
                                            className={"listgo-btn btn-primary pull-right"}
                                            onClick={scrollToTop}
                                            ><i className="fa fa-arrow-up"/>
                                        </a>
                                    </Clearfix>
                                </AutoAffix>

                                {this.renderResultList(loading, data)}
                            </Row>
                        }}
                    </Query>
                </Grid>
            </div>
        </section></>;
    }

    private renderFilters(data: any) {
        const entityId = this.props.activeEntity.id;
        const facets: EntityFacets = (data && data[entityId] && data[entityId].facets) || {};
        const onChange = (f: EntityFilters) => {
            this.setState({filters: f});
            const params = EntityFiltersSerializer.serialize(f, new URLSearchParams(this.props.history.location.search));
            this.props.history.push(`/${this.props.activeEntity.id}/zoeken/pagina/1?${params}`);
        }
        return <FilterContainer
            activeFilters={this.state.filters}
            key={this.props.activeEntity.id}
            onChange={onChange}
            filters={this.props.activeEntity.fields.filter(f => f.searchable)}
            facets={facets}
        />
    }

    private buildQuery() {
        const entity = this.props.activeEntity;
        const searchableFields = entity.fields.filter(f => f.searchable);
        const inputArgumentBuilder = new InputArgumentTypeFactory(entity.id);
        const variables = searchableFields.map(f => `\$${f.id}: ${inputArgumentBuilder.visit(f)}`).join(', ');
        const facets = searchableFields.filter(f => f.type === FieldType.Enum || f.type === FieldType.Boolean)
            .map((f: IField) => {
                switch (f.type) {
                    case FieldType.Boolean:
                       const boolField = f as BooleanField;
                        return `${boolField.id} { true, false }`;
                    case FieldType.Enum:
                        const enumField = f as EnumField
                        return `${enumField.id} { ${enumField.options.map(o =>(o.key.toLowerCase()).replace(/\s/g, '_')).join(', \n')}}`;
                    case FieldType.Array:
                    case FieldType.Image:
                    case FieldType.LengthInterval:
                    case FieldType.Text:
                        throw new Error("Unsupported resultCount " + f.type + " " + f.id);

                }
            }).join(',\n');
        const results = entity.fields.map(f => {
            switch (f.type) {
                case FieldType.LengthInterval:
                    return `${f.id} { min , max, __typename @skip(if: true) }`;
                default:
                    return f.id;

            }
        }).join(',\n');
        const q = `
        query getData($offset:Int, $limit: Int, ${variables}){
            ${entity.id}(offset: $offset, limit: $limit, ${searchableFields.map(f => `${f.id}:\$${f.id}`).join(', ')}) {
                count,
                facets {
                    ${facets}
                },
                results {
                    ${results}
                }
            }
        }`;
        return gql(q);
    };

    private renderResultList(loading: boolean, data: any) {
        const entityId = this.props.activeEntity.id;
        const results = data && data[entityId] && data[entityId].results || [];
        const count = data && data[entityId] && data[entityId].count || null;
        return <Col md={9} sm={12}>
            <Row>
                <Col>
                    <div className="listing__result-right">
                        <span><ins>{count === null ? "" : `${count} resultaten`}</ins></span>
                        <a href="#" className="hidden-xs hidden-sm" onClick={this.clearFilters}>Reset</a>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    {results.length > 0 ? results.map((r: any) => this.searchResultComponentFactory.build(this.props.activeEntity, this.props.history, this.props.page, r)) :
                        (!loading ? <h3>Er konden helaas geen resultaten gevonden worden</h3> : undefined)
                    }
                    {loading ? <Col md={9}>
                            <Row>
                                <Col>
                                    <Loader innerClassName={"center-block size-x2"} type="ball-grid-pulse" active={true}/>
                                </Col>
                            </Row>
                        </Col>
                        : (count !== null) ?
                            <Pagination entityId={this.props.activeEntity.id} totalResults={count} search={this.props.history.location.search} currentPage={this.props.page} pageSize={30}/> : undefined}
                </Col>
            </Row>
        </Col>;
    }

    private clearFilters(e: any) {
        this.setState({filters: {}});
        this.props.history.push(`/${this.props.activeEntity.id}/zoeken/pagina/1`);
        e.preventDefault();
    }
}




// WEBPACK FOOTER //
// ./src/homepage/homepage.tsx